import { render } from "./UiTextareaReadOnly.pug?vue&type=template&id=e806a1aa&lang=pug"
import script from "./UiTextareaReadOnly.js?vue&type=script&lang=js"
export * from "./UiTextareaReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__